/**
 * Quita los guiones de un número de póliza
 * @param poliza Póliza con o sin guiones
 * @returns Póliza solo con dígitos
 */
export function unformatPolicy(poliza?: string | number | null): string {
    if (poliza === null || poliza === undefined || poliza === '') return '';
  
    const value = String(poliza);
    if (value === 'NaN') return '';
  
    return value.replaceAll('-', '');
  }
  